import type {MobileAuthedWebviewEntryPointConfig} from '../ConnectElementList';

export const EditPayoutScheduleConfig: MobileAuthedWebviewEntryPointConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "EditPayoutSchedule" */
      '../../../components/Account/PayoutInformation/PayoutSchedule/EditPayoutScheduleEntryPoint'
    ),
  description: 'Mobile authed webview entry point to edit payout schedule',
  friendlyName: 'Mobile entry point: edit payout schedule',
};
